export const servicesTranslations = {
    en: {
        pageTitle: "Our Services",
        pageSubtitle: "Powered by a 20+ member backend team, experienced field officers, strong police liaison capability, and IBNR–FFRM project experience since Aug 2022",
        heroDesc: "GSA delivers structured, evidence-driven investigation and risk-verification services across Punjab and Haryana.",
        motor: {
            title: "Motor Insurance Investigations",
            subtitle: "TP, OD & Theft Claims",
            intro: "End-to-end technical verification of motor claims with police-verified ground evidence.",
            tp: {
                title: "Third-Party (TP) Claims",
                items: [
                    "Accident legitimacy & police record verification",
                    "Victim and occupant confirmation",
                    "Place of Occurrence (POO) mapping",
                    "Witness tracing & police statement correlation"
                ]
            },
            od: {
                title: "Own Damage (OD) Scrutiny",
                items: [
                    "Damage vs loss cause correlation",
                    "Police intimation consistency",
                    "Pre-existing damage detection"
                ]
            },
            theft: {
                title: "Theft Investigations",
                items: [
                    "FIR authenticity & police station verification",
                    "Theft circumstance validation",
                    "Key-set authenticity",
                    "Untraced report coordination"
                ]
            }
        },
        police: {
            title: "Police Liaison & Statutory Coordination",
            subtitle: "Professional Law Enforcement Coordination",
            intro: "Professional dealing and coordination with law-enforcement agencies.",
            catTitle: "Direct Police Coordination",
            items: [
                "Direct liaison with Police Stations & Investigating Officers",
                "FIR / DDR / accident record confirmation",
                "Charge-sheet (173 CrPC) verification",
                "Case status & investigation updates",
                "SSP / SHO / IO office coordination"
            ]
        },
        rti: {
            title: "RTI Expert Services",
            subtitle: "Right to Information",
            intro: "RTI-based retrieval of certified police and government records.",
            catTitle: "RTI Services",
            items: [
                "RTI drafting & filing with Police, RTO & Hospitals",
                "Certified FIR, DDR, MLC & investigation records",
                "Difficult police document procurement",
                "Legally admissible evidence"
            ]
        },
        ibnr: {
            title: "IBNR & FFRM Risk Verification",
            subtitle: "Since August 2022",
            intro: "Portfolio-level and early-stage insurance risk detection support.",
            catTitle: "Risk Verification Services",
            items: [
                "IBNR (Incurred But Not Reported) investigation",
                "FFRM claim-risk verification assignments",
                "Suspicious pattern identification",
                "Pre-claim field validation",
                "Policy-stage risk intelligence inputs"
            ]
        },
        cta: {
            title: "Need Expert Investigation Services?",
            desc: "Contact us today for comprehensive insurance investigation and risk verification",
            btnPrimary: "Request Investigation",
            btnSecondary: "Call +91-9814974333"
        }
    },
    hi: {
        pageTitle: "हमारी सेवाएं",
        pageSubtitle: "20+ सदस्यीय बैकएंड टीम, अनुभवी क्षेत्र अधिकारियों, मजबूत पुलिस संपर्क क्षमता और अगस्त 2022 से IBNR-FFRM परियोजना अनुभव द्वारा संचालित",
        heroDesc: "GSA पंजाब और हरियाणा में संरचित, साक्ष्य-संचालित जांच और जोखिम-सत्यापन सेवाएं प्रदान करता है।",
        motor: {
            title: "मोटर बीमा जांच",
            subtitle: "TP, OD और चोरी के दावे",
            intro: "पुलिस-सत्यापित जमीनी सबूतों के साथ मोटर दावों का एंड-टू-एंड तकनीकी सत्यापन।",
            tp: {
                title: "तृतीय-पक्ष (TP) दावे",
                items: [
                    "दुर्घटना वैधता और पुलिस रिकॉर्ड सत्यापन",
                    "पीड़ित और रहने वाले की पुष्टि",
                    "घटना स्थल (POO) मानचित्रण",
                    "गवाह का पता लगाना और पुलिस बयान सहसंबंध"
                ]
            },
            od: {
                title: "स्वयं क्षति (OD) जांच",
                items: [
                    "नुकसान बनाम हानि कारण सहसंबंध",
                    "पुलिस सूचना स्थिरता",
                    "पूर्व-मौजूद क्षति का पता लगाना"
                ]
            },
            theft: {
                title: "चोरी की जांच",
                items: [
                    "एफआईआर प्रमाणिकता और पुलिस स्टेशन सत्यापन",
                    "चोरी की परिस्थिति का सत्यापन",
                    "की-सेट प्रमाणिकता",
                    "अनट्रेस्ड रिपोर्ट समन्वय"
                ]
            }
        },
        police: {
            title: "पुलिस संपर्क और वैधानिक समन्वय",
            subtitle: "कानून प्रवर्तन समन्वय",
            intro: "कानून प्रवर्तन एजेंसियों के साथ पेशेवर व्यवहार और समन्वय।",
            catTitle: "सीधा पुलिस समन्वय",
            items: [
                "पुलिस स्टेशनों और जांच अधिकारियों के साथ सीधा संपर्क",
                "एफआईआर / डीडीआर / दुर्घटना रिकॉर्ड की पुष्टि",
                "चार्जशीट (173 सीआरपीसी) सत्यापन",
                "केस की स्थिति और जांच अपडेट",
                "एसएसपी / एसएचओ / आईओ कार्यालय समन्वय"
            ]
        },
        rti: {
            title: "आरटीआई विशेषज्ञ सेवाएं",
            subtitle: "सूचना का अधिकार",
            intro: "प्रमाणित पुलिस और सरकारी रिकॉर्ड की आरटीआई-आधारित पुनर्प्राप्ति।",
            catTitle: "आरटीआई सेवाएं",
            items: [
                "पुलिस, आरटीओ और अस्पतालों के साथ आरटीआई का मसौदा तैयार करना और दाखिल करना",
                "प्रमाणित एफआईआर, डीडीआर, एमएलसी और जांच रिकॉर्ड",
                "कठिन पुलिस दस्तावेज़ की खरीद",
                "कानूनी रूप से स्वीकार्य सबूत"
            ]
        },
        ibnr: {
            title: "IBNR और FFRM जोखिम सत्यापन",
            subtitle: "अगस्त 2022 से",
            intro: "पोर्टफोलियो-स्तरीय और प्रारंभिक चरण बीमा जोखिम का पता लगाने में सहायता।",
            catTitle: "जोखिम सत्यापन सेवाएं",
            items: [
                "IBNR (घटित लेकिन रिपोर्ट नहीं किया गया) जांच",
                "FFRM दावा-जोखिम सत्यापन कार्य",
                "संदिग्ध पैटर्न की पहचान",
                "पूर्व-दावा फील्ड सत्यापन",
                "पॉलिसी-स्टेज जोखिम खुफिया इनपुट"
            ]
        },
        cta: {
            title: "विशेषज्ञ जांच सेवाओं की आवश्यकता है?",
            desc: "व्यापक बीमा जांच और जोखिम सत्यापन के लिए आज ही हमसे संपर्क करें",
            btnPrimary: "जांच का अनुरोध करें",
            btnSecondary: "कॉल करें +91-9814974333"
        }
    },
    pa: {
        pageTitle: "ਸਾਡੀਆਂ ਸੇਵਾਵਾਂ",
        pageSubtitle: "20+ ਸਦੱਸ, ਤਜਰਬੇਕਾਰ ਖੇਤਰੀ ਅਫਸਰ, ਮਜ਼ਬੂਤ ਪੁਲਿਸ ਤਾਲਮੇਲ ਸਮਰੱਥਾ, ਅਤੇ ਅਗਸਤ 2022 ਤੋਂ IBNR-FFRM ਪ੍ਰੋਜੈਕਟ ਅਨੁਭਵ ਦੁਆਰਾ ਸੰਚਾਲਿਤ",
        heroDesc: "GSA ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਵਿੱਚ ਢਾਂਚਾਗਤ, ਸਬੂਤ-ਅਧਾਰਿਤ ਜਾਂਚ ਅਤੇ ਜੋਖਮ-ਸਤਿਆਪਨ ਸੇਵਾਵਾਂ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ।",
        motor: {
            title: "ਮੋਟਰ ਬੀਮਾ ਜਾਂਚ",
            subtitle: "TP, OD ਅਤੇ ਚੋਰੀ ਦੇ ਦਾਅਵੇ",
            intro: "ਪੁਲਿਸ ਦੁਆਰਾ ਪ੍ਰਮਾਣਿਤ ਜ਼ਮੀਨੀ ਸਬੂਤਾਂ ਦੇ ਨਾਲ ਮੋਟਰ ਦਾਅਵਿਆਂ ਦੀ ਸ਼ੁਰੂ ਤੋਂ ਅੰਤ ਤੱਕ ਤਕਨੀਕੀ ਤਸਦੀਕ।",
            tp: {
                title: "ਥਰਡ-ਪਾਰਟੀ (TP) ਦਾਅਵੇ",
                items: [
                    "ਹਾਦਸੇ ਦੀ ਜਾਇਜ਼ਤਾ ਅਤੇ ਪੁਲਿਸ ਰਿਕਾਰਡ ਦੀ ਤਸਦੀਕ",
                    "ਪੀੜਤ ਅਤੇ ਸਵਾਰ ਦੀ ਪੁਸ਼ਟੀ",
                    "ਘਟਨਾ ਸਥਾਨ (POO) ਮੈਪਿੰਗ",
                    "ਗਵਾਹ ਦਾ ਪਤਾ ਲਗਾਉਣਾ ਅਤੇ ਪੁਲਿਸ ਬਿਆਨ ਸਬੰਧ"
                ]
            },
            od: {
                title: "ਆਪਣਾ ਨੁਕਸਾਨ (OD) ਜਾਂਚ",
                items: [
                    "ਨੁਕਸਾਨ ਬਨਾਮ ਨੁਕਸਾਨ ਦਾ ਕਾਰਨ ਸਬੰਧ",
                    "ਪੁਲਿਸ ਇੰਟੀਮੇਸ਼ਨ ਇਕਸਾਰਤਾ",
                    "ਪਹਿਲਾਂ ਤੋਂ ਮੌਜੂਦ ਨੁਕਸਾਨ ਦੀ ਖੋਜ"
                ]
            },
            theft: {
                title: "ਚੋਰੀ ਦੀ ਜਾਂਚ",
                items: [
                    "ਐਫਆਈਆਰ ਦੀ ਪ੍ਰਮਾਣਿਕਤਾ ਅਤੇ ਪੁਲਿਸ ਸਟੇਸ਼ਨ ਦੀ ਤਸਦੀਕ",
                    "ਚੋਰੀ ਦੇ ਹਾਲਾਤ ਦੀ ਪੁਸ਼ਟੀ",
                    "ਕੀ-ਸੈੱਟ ਪ੍ਰਮਾਣਿਕਤਾ",
                    "ਅਣਟਰੇਸਡ ਰਿਪੋਰਟ ਤਾਲਮੇਲ"
                ]
            }
        },
        police: {
            title: "ਪੁਲਿਸ ਸੰਪਰਕ ਅਤੇ ਕਾਨੂੰਨੀ ਤਾਲਮੇਲ",
            subtitle: "ਕਾਨੂੰਨ ਲਾਗੂ ਕਰਨ ਵਾਲੇ ਤਾਲਮੇਲ",
            intro: "ਕਾਨੂੰਨ ਲਾਗੂ ਕਰਨ ਵਾਲੀਆਂ ਏਜੰਸੀਆਂ ਨਾਲ ਪੇਸ਼ੇਵਰ ਵਿਵਹਾਰ ਅਤੇ ਤਾਲਮੇਲ।",
            catTitle: "ਸਿੱਧਾ ਪੁਲਿਸ ਤਾਲਮੇਲ",
            items: [
                "ਪੁਲਿਸ ਸਟੇਸ਼ਨਾਂ ਅਤੇ ਜਾਂਚ ਅਫਸਰਾਂ ਨਾਲ ਸਿੱਧਾ ਸੰਪਰਕ",
                "ਐਫਆਈਆਰ / ਡੀਡੀਆਰ / ਹਾਦਸੇ ਦੇ ਰਿਕਾਰਡ ਦੀ ਪੁਸ਼ਟੀ",
                "ਚਾਰਜਸ਼ੀਟ (173 CrPC) ਤਸਦੀਕ",
                "ਕੇਸ ਦੀ ਸਥਿਤੀ ਅਤੇ ਜਾਂਚ ਅੱਪਡੇਟ",
                "ਐਸਐਸਪੀ / ਐਸਐਚਓ / ਆਈਓ ਦਫਤਰ ਤਾਲਮੇਲ"
            ]
        },
        rti: {
            title: "ਆਰਟੀਆਈ ਮਾਹਰ ਸੇਵਾਵਾਂ",
            subtitle: "ਸੂਚਨਾ ਦਾ ਅਧਿਕਾਰ",
            intro: "ਪ੍ਰਮਾਣਿਤ ਪੁਲਿਸ ਅਤੇ ਸਰਕਾਰੀ ਰਿਕਾਰਡਾਂ ਦੀ ਆਰਟੀਆਈ-ਅਧਾਰਤ ਪ੍ਰਾਪਤੀ।",
            catTitle: "ਆਰਟੀਆਈ ਸੇਵਾਵਾਂ",
            items: [
                "ਪੁਲਿਸ, ਆਰਟੀਓ ਅਤੇ ਹਸਪਤਾਲਾਂ ਨਾਲ ਆਰਟੀਆਈ ਦਾ ਖਰੜਾ ਤਿਆਰ ਕਰਨਾ ਅਤੇ ਦਾਇਰ ਕਰਨਾ",
                "ਪ੍ਰਮਾਣਿਤ ਐਫਆਈਆਰ, ਡੀਡੀਆਰ, ਐਮਐਲਸੀ ਅਤੇ ਜਾਂਚ ਰਿਕਾਰਡ",
                "ਮੁਸ਼ਕਲ ਪੁਲਿਸ ਦਸਤਾਵੇਜ਼ ਦੀ ਖਰੀਦ",
                "ਕਾਨੂੰਨੀ ਤੌਰ 'ਤੇ ਸਵੀਕਾਰਯੋਗ ਸਬੂਤ"
            ]
        },
        ibnr: {
            title: "IBNR ਅਤੇ FFRM ਜੋਖਮ ਤਸਦੀਕ",
            subtitle: "ਅਗਸਤ 2022 ਤੋਂ",
            intro: "ਪੋਰਟਫੋਲੀਓ-ਪੱਧਰ ਅਤੇ ਸ਼ੁਰੂਆਤੀ ਪੜਾਅ ਦੇ ਬੀਮਾ ਜੋਖਮ ਖੋਜ ਸਹਾਇਤਾ।",
            catTitle: "ਜੋਖਮ ਤਸਦੀਕ ਸੇਵਾਵਾਂ",
            items: [
                "IBNR (ਵਾਪਰਿਆ ਪਰ ਰਿਪੋਰਟ ਨਹੀਂ ਕੀਤਾ ਗਿਆ) ਜਾਂਚ",
                "FFRM ਦਾਅਵਾ-ਜੋਖਮ ਤਸਦੀਕ ਅਸਾਈਨਮੈਂਟ",
                "ਸ਼ੱਕੀ ਪੈਟਰਨ ਦੀ ਪਛਾਣ",
                "ਪ੍ਰੀ-ਕਲੇਮ ਫੀਲਡ ਵੈਧਤਾ",
                "ਪਾਲਿਸੀ-ਪੜਾਅ ਜੋਖਮ ਖੁਫੀਆ ਜਾਣਕਾਰੀ"
            ]
        },
        cta: {
            title: "ਮਾਹਰ ਜਾਂਚ ਸੇਵਾਵਾਂ ਦੀ ਲੋੜ ਹੈ?",
            desc: "ਵਿਆਪਕ ਬੀਮਾ ਜਾਂਚ ਅਤੇ ਜੋਖਮ ਤਸਦੀਕ ਲਈ ਅੱਜ ਹੀ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
            btnPrimary: "ਜਾਂਚ ਦੀ ਬੇਨਤੀ ਕਰੋ",
            btnSecondary: "ਕਾਲ ਕਰੋ +91-9814974333"
        }
    }
};
